"use client";

import { useState } from "react";
import { ArrowRight, Pause, Play, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheStageExperience() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [activeId, setActiveId] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const projects = [{
    id: 1,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_keynote_stage.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_keynote_stage.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_keynote_stage.png-wvc-sizes",
    title: "The Resilience Mindset",
    client: "Global Leadership Summit",
    episodes: "LIVE KEYNOTE",
    duration: "45M 00S",
    span: "large",
    offset: false
  }, {
    id: 2,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_audience_reaction.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_audience_reaction.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_audience_reaction.png-wvc-sizes",
    title: "Leading with Empathy",
    client: "Fortune 500 Workshop",
    episodes: "MASTERCLASS",
    duration: "1H 15M",
    span: "small",
    offset: true
  }, {
    id: 3,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_podcast_interview.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_podcast_interview.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_podcast_interview.png-wvc-sizes",
    title: "The Command Stage",
    client: "Leadership Uncut Podcast",
    episodes: "INTERVIEW",
    duration: "52M 10S",
    span: "small",
    offset: false
  }, {
    id: 4,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_performance_energy.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_performance_energy.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_performance_energy.webp-wvc-sizes",
    title: "Radical Accountability",
    client: "Tech Innovators Expo",
    episodes: "MAIN STAGE",
    duration: "38M 22S",
    span: "large",
    offset: true
  }, {
    id: 5,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_workshop_interaction.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_workshop_interaction.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_workshop_interaction.png-wvc-sizes",
    title: "Future of Influence",
    client: "Executive Retreat",
    episodes: "STRATEGY SESSION",
    duration: "2H 30M",
    span: "large",
    offset: false
  }, {
    id: 6,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_backstage_prep.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_backstage_prep.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698923/img/damien_cole_backstage_prep.png-wvc-sizes",
    title: "The Momentum Shift",
    client: "Sales Kickoff 2024",
    episodes: "OPENING KEYNOTE",
    duration: "55M 12S",
    span: "small",
    offset: true
  }];
  const togglePlay = (project: any) => {
    setSelectedProject(project);
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    setSelectedProject(null);
  };
  return <section data-section-id="5034" id="the-stage-experience" className="bg-background text-foreground py-24 md:py-32 lg:py-48 px-6 md:px-12 lg:px-20 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-8">
            
            <h2 className="font-default font-black text-5xl md:text-7xl lg:text-[88px] leading-[0.9] tracking-tighter text-foreground uppercase">
              Moments of{" "}
              <span className="italic font-black" style={{
              color: "var(--chart-1)"
            }}>
                impact
              </span>{" "}
              captured.
            </h2>
          </div>
          <div className="lg:col-span-4 flex lg:items-end lg:justify-end">
            <p className="text-base md:text-lg font-default text-muted-foreground max-w-sm lg:text-right leading-relaxed">
              High-energy performances and leadership insights from global stages.
            </p>
          </div>
        </div>

        
        <div ref={gridRef} className="mt-20 md:mt-28 lg:mt-32 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 lg:gap-10">
          {projects.map((project, i) => {
          const isLarge = project.span === "large";
          const colSpan = isLarge ? "md:col-span-7" : "md:col-span-5";
          const offsetClass = project.offset ? "md:mt-16 lg:mt-20" : "";
          const aspectClass = isLarge ? "aspect-[4/3]" : "aspect-[3/4]";
          const isActive = activeId === project.id;
          return <div key={project.id} data-index={i} className={`group ${colSpan} ${offsetClass} transition-all duration-1000 ease-out`} style={{
            opacity: gridVisible ? 1 : 0,
            transform: gridVisible ? "translateY(0)" : "translateY(40px)",
            transitionDelay: `${i * 120}ms`
          }}>
                <Button onClick={() => togglePlay(project)} variant="ghost" className="w-full text-left p-0 h-auto hover:bg-transparent focus-visible:ring-0" aria-label={`Play ${project.title}`}>
                  <div className={`relative w-full ${aspectClass} overflow-hidden rounded-md border-l-4`} style={{
                borderLeftColor: "var(--chart-1)"
              }}>
                    
                    <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.title} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-out grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100" />

                    
                    <div className="absolute inset-0 pointer-events-none mix-blend-overlay opacity-20" style={{
                  backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
                }} />

                    
                    <div className="absolute inset-0 pointer-events-none" style={{
                  background: "linear-gradient(to top, hsl(215, 25%, 10%) 0%, transparent 60%)"
                }} />

                    
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center transition-all duration-500 ease-out group-hover:scale-110 backdrop-blur-md" style={{
                    border: "2px solid var(--chart-1)",
                    backgroundColor: "hsla(45, 100%, 50%, 0.1)",
                    borderRadius: "4px"
                  }}>
                        {isActive ? <Pause className="w-5 h-5 md:w-6 md:h-6" style={{
                      color: "var(--chart-1)"
                    }} strokeWidth={2} /> : <Play className="w-5 h-5 md:w-6 md:h-6 ml-0.5" style={{
                      color: "var(--chart-1)"
                    }} strokeWidth={2} fill="currentColor" />}
                      </div>
                    </div>

                    
                    <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-white/10 overflow-hidden">
                      <div className="h-full transition-all duration-700 ease-out" style={{
                    backgroundColor: "var(--chart-1)",
                    width: isActive ? "100%" : "0%",
                    transform: !isActive ? "translateX(-100%)" : "translateX(0)"
                  }} />
                    </div>
                  </div>

                  
                  <div className="mt-5 md:mt-6 text-left">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="font-mono text-[11px] md:text-xs tracking-widest font-semibold" style={{
                    color: "var(--chart-1)"
                  }}>
                        {project.episodes}
                      </span>
                      <span className="w-1 h-1 rounded-md bg-muted-foreground/30" />
                      <span className="font-mono text-[11px] md:text-xs tracking-widest font-semibold" style={{
                    color: "var(--chart-1)"
                  }}>
                        {project.duration}
                      </span>
                    </div>
                    <h3 className="font-default font-bold text-xl md:text-2xl text-foreground leading-snug mb-1 uppercase tracking-tight">
                      {project.title}
                    </h3>
                    <p className="font-default text-[13px] text-muted-foreground tracking-wide">
                      {project.client}
                    </p>
                  </div>

                  
                  {isActive && <div className="mt-4 p-4 rounded-md border-l-2 text-left shadow-lg w-full max-w-full overflow-hidden" style={{
                backgroundColor: "var(--card)",
                borderColor: "var(--chart-1)"
              }}>
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-2 h-2 rounded-md animate-pulse" style={{
                    backgroundColor: "var(--chart-1)"
                  }} />
                        <span className="font-mono text-[10px] tracking-widest font-bold" style={{
                    color: "var(--chart-1)"
                  }}>
                          STREAMING NOW — HIGHLIGHTS
                        </span>
                      </div>
                      <Progress value={34} className="h-1 bg-white/10" />
                      <div className="flex justify-between mt-2 font-mono text-[10px] text-muted-foreground">
                        <span>00:12:48</span>
                        <span>{project.duration}</span>
                      </div>
                    </div>}
                </Button>
              </div>;
        })}
        </div>

        {showModal && selectedProject && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8">
            <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={closeModal} />
            <div className="relative w-full max-w-4xl bg-card rounded-md overflow-hidden shadow-2xl border border-white/10 animate-in fade-in zoom-in duration-300">
              <div className="flex items-center justify-between p-4 md:p-6 border-b border-white/10">
                <h3 className="font-default font-black text-xl md:text-2xl uppercase tracking-tight text-foreground">
                  {selectedProject.title}
                </h3>
                <Button variant="ghost" size="icon" onClick={closeModal} className="hover:bg-white/10 text-foreground">
                  <X className="w-6 h-6" />
                </Button>
              </div>
              <div className="aspect-video bg-black flex items-center justify-center relative group">
                <div className="absolute inset-0 opacity-40 grayscale" style={{
              backgroundImage: `url(${selectedProject.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }} />
                <div className="relative z-10 flex flex-col items-center gap-4">
                  <div className="w-20 h-20 flex items-center justify-center rounded-md border-2 border-primary bg-primary/10 backdrop-blur-md">
                    <Play className="w-8 h-8 text-primary fill-current ml-1" />
                  </div>
                  <p className="font-mono text-xs tracking-widest text-primary font-bold uppercase">
                    Loading High-Definition Stream...
                  </p>
                </div>
              </div>
              <div className="p-4 md:p-6 bg-muted/30">
                <div className="flex flex-wrap gap-4 items-center text-sm">
                  <span className="font-mono text-primary font-bold">{selectedProject.episodes}</span>
                  <span className="text-muted-foreground">|</span>
                  <span className="text-foreground font-semibold">{selectedProject.client}</span>
                  <span className="text-muted-foreground">|</span>
                  <span className="font-mono text-muted-foreground">{selectedProject.duration}</span>
                </div>
              </div>
            </div>
          </div>}

        
        <div className="mt-24 md:mt-32 flex justify-center">
          <Button asChild variant="ghost" className="group font-default font-bold text-base md:text-lg text-foreground hover:bg-transparent px-0 h-auto py-3 uppercase tracking-wider">
            <Link to="/DamienColePage" className="inline-flex items-center gap-3">
              <span className="relative">
                Download Speaker Sheet
                <span className="absolute left-0 right-0 -bottom-1 h-[2px] transition-all duration-500 group-hover:opacity-100 opacity-40" style={{
                backgroundColor: "var(--chart-1)"
              }} />
              </span>
              <ArrowRight className="w-5 h-5 transition-transform duration-500 group-hover:translate-x-2" style={{
              color: "var(--chart-1)"
            }} strokeWidth={2} />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}